import { ACTION_TYPES } from '../constants';

export default (url: string, originUrl: string) => ({
  type: ACTION_TYPES.FETCH_MORE_VOD_REQUEST,
  payload: {
    url,
    originUrl
  }
});
